import { BaseQueryFn, createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { manager } from '../common/auth/auth';

const baseQueryWithToken: BaseQueryFn = async (args, api, extraOptions) => {
    const accessToken = await manager.getUser().then((user) => {
        return user?.access_token;
    }).catch((error) => {
        console.log(error);
        return error;
    });

    if(!accessToken)
        return { error: 'No access token'};

    return fetchBaseQuery({
        baseUrl: `${import.meta.env.VITE_DATA_API}/api/`,
        prepareHeaders: headers => {
            headers.set('authorization', `Bearer ${accessToken}`)
            return headers;
        }
    })(args, api, extraOptions);
}

const dataApi = createApi({
  baseQuery: baseQueryWithToken,
  endpoints: () => ({}),
  reducerPath: 'datapi'
});

export default dataApi;